export const dropDowns = {
  "Variable Speed": ["Yes", "No"],
  "Foundation": ["Select", "Rigid", "Flexible"],
  "Load Rating Unit": ["HP", "kW"],
  "Type": ["Centrifugal", "Positive Displacement", "Axial Flow", "Axial", "Dry Type", "Oil Immersed"],
  "Sub Type": [ "Reciprocating", "Lobe", "Screw", "Vane", "Liquid Ring", "Scroll"],
  "Input Shaft Direction": ["horizontal", "vertical"],
  "Output Shaft Direction": ["horizontal", "vertical"],
  "Phase": ["1", "3"],
  "axial": ['X', 'Y', 'Z'],
  "vertical": ['X', 'Y', 'Z']
};

export const componentClassNames = ["driver", "connector", "driven"];
